import React from "react";
import img1 from "../../assets/chandranath.jpg";
import img2 from "../../assets/jharna.jpg";

const Article2 = () => {
  return (
    <section className="">
      <div className="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl">
        <div>
          <h2 className="text-3xl font-bold tracking-tight text-center sm:text-5xl ">
            Stay with Tra<span className="text-orange-700">Vlog</span>
          </h2>
          <p className="max-w-3xl mx-auto mt-4 text-xl text-center ">
            Every tour has its separate memory.keep rock and more trip with
            Travlog
          </p>
        </div>
        <div className="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <h3 className="text-2xl font-bold tracking-tight sm:text-3xl dark:text-gray-50">
              Chandranath at Chottogram
            </h3>
            <p className="mt-3 text-lg ">
              Chandranath hill is the right place for those who likes Climbing.
              The small hill group of Chandranath starts from Bichkunda. On the
              way to Chandranath hill you will see some of the religious places
              of Hindus religion.
            </p>
            <div className="mt-12 space-y-12">
              <div className="flex">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center w-12 h-12 rounded-md ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-7 h-7"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <p className="mt-2 ">
                    Chittagong is on the direct route from Dhaka. There is
                    available A/C & none A/C bus service 24 hours a day. U can
                    also use train or Air (Biman). First you have to come to
                    Sitakunda from Chittagong by Bus
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center w-12 h-12 rounded-md ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-7 h-7"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <p className="mt-2 ">
                    Sitakunda Bazar. Chandranath hill stands 3.5 kilometers east
                    from Sitakunda Bazar. You can go Chandranath hill side with
                    a rickshaw or on foot.
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center w-12 h-12 rounded-md ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-7 h-7"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <p className="mt-2 ">
                    Dhaka and Chittagong are linked by road. You can take a bus
                    from Dhaka to reach the district of Chittagong. Some of the
                    bus services are listed below for our assistance.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div aria-hidden="true" className="mt-10 lg:mt-0">
            <img
              src={img1}
              alt=""
              className="mx-auto rounded-lg shadow-lg dark:bg-gray-500"
            />
          </div>
        </div>
        <div>
          <div className="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
            <div className="lg:col-start-2">
              <h3 className="text-2xl font-bold tracking-tight sm:text-3xl dark:text-gray-50">
                Khoiyachora at Feni
              </h3>
              <p className="mt-3 text-lg ">
                It is one of the largest waterfalls in Bangladesh. It has 9
                amazing steps that makes it unique. Really beautiful atmosphere
                with good flow of water and green forests around. But the trail
                to this fall is a but risky. So travelers must be careful.
                Highly recommended for the advnture lovers.
              </p>
              <div className="mt-12 space-y-12">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 rounded-md ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <p className="mt-2 ">
                      To visit Khoiya Chora waterfall you will have to get off
                      from the bus at Bartakiya bazaar, Mirsharai on
                      Dhaka-Chittagong highway. Then take a CNG from Bartakiya
                      to Rail gate.
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 rounded-md ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <p className="mt-2 ">
                      {" "}
                      Then just follow the road, after a while you will see the
                      Chara/Jiri Path (water stream,) now follow this chara.
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 rounded-md ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <p className="mt-2 ">
                      There is a local man made footpath which is following the
                      Chara/Jiri path. So use the footpath, after half an hour
                      you will see some houses. Then use your right hand path
                      which will lead to the waterfall.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-10 lg:mt-0 lg:col-start-1 lg:row-start-1">
              <img
                src={img2}
                alt=""
                className="mx-auto rounded-lg shadow-lg dark:bg-gray-500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Article2;